import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueFormWizard from 'vue-form-wizard'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import mixins from './mixins/global'

Vue.use(VueFormWizard)
mixins.create(Vue);

Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD1uTG0w8tGesACFSPSvei1J0szOsr2wf0', 
    libraries: 'places'

}})
new Vue({
  render: h => h(App)
}).$mount('#app')
